const Immutable = require('immutable');
const Util = require('es6!sumo/util');
const Actions = require('./actions');

const initialState = Immutable.Map({
  // Tracks whether the feature flags have been loaded
  isReady: false,
  // Tracks whether we are currently loading feature flags
  isLoading: false,
  // Tracks the list of feature flags
  list: Immutable.List(),
});

const actionHandlers = {};

actionHandlers[Actions.FETCH_FEATURE_FLAGS] = (state) => state.merge({
  isLoading: true,
});

actionHandlers[Actions.FETCH_FEATURE_FLAGS_SUCCESS] = (state, action) => state.merge({
  isReady: true,
  isLoading: false,
  list: action.payload,
});

module.exports = Util.createReducer(initialState, actionHandlers);
